"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartQueryBuilderPlugin = exports.BarChartQueryBuilder = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const ChartAxisOptionsConfig_1 = __importDefault(require("../common/charts/ChartAxisOptionsConfig"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const StyledConfigFieldControl = (0, styled_components_1.default)(core_ui_1.ConfigFieldControl) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const axisOptions = [
    { label: 'Top', key: 'axisTop' },
    { label: 'Right', key: 'axisRight' },
    { label: 'Bottom', key: 'axisBottom' },
    { label: 'Left', key: 'axisLeft' }
];
const BarChartQueryBuilder = props => {
    const { type, params } = props;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const update = (updateParams = {}) => {
        var _a, _b, _c, _d;
        const index = (_d = (_c = (_b = (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.pluginConfigs) === null || _c === void 0 ? void 0 : _c.findIndex(pluginConfig => pluginConfig.type === type)) !== null && _d !== void 0 ? _d : -1;
        queryManager.updatePluginConfig(index, {
            type: exports.BarChartQueryBuilderPlugin.type,
            params: Object.assign(Object.assign({}, params), updateParams)
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, value: params.field || null, options: queryManager.queryAliasColumnMap.map(columnMap => columnMap.path), onChange: (_, value) => {
                    params.field = value || undefined;
                    update();
                }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Select Field' }))) }),
            react_1.default.createElement(core_1.FormHelperText, null, "Select the field value to be display on the chart")),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, value: params.layout || 'vertical', options: ['horizontal', 'vertical'], onChange: (_, value) => {
                    params.layout = value || undefined;
                    update();
                }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Select Layout' }))) })),
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(core_1.TextField, { type: 'number', fullWidth: true, size: 'small', variant: 'outlined', label: 'Chart Height', value: params.chartHeight, onChange: event => {
                    const value = event.target.value
                        ? parseInt(event.target.value)
                        : undefined;
                    params.chartHeight = value;
                    update();
                } }),
            react_1.default.createElement(core_1.FormHelperText, null, "Custom Chart Height (Default: 300px)")),
        axisOptions.map((option, index) => (react_1.default.createElement(ChartAxisOptionsConfig_1.default, { key: index, axisLabel: option.label, enabled: !!params[option.key], value: params[option.key] || {}, onEnable: checked => {
                params[option.key] = checked ? {} : undefined;
                update();
            }, onChange: value => {
                params[option.key] = Object.assign(Object.assign({}, params[option.key]), value);
                update();
            } }))),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Integer Axis Ticks Only', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.integerTicksOnly, onChange: () => {
                        params.integerTicksOnly = !params.integerTicksOnly;
                        update();
                    } }) })),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Show Legends', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.showLegends, onChange: () => {
                        params.showLegends = !params.showLegends;
                        update();
                    } }) })),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Exclude Null Values', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.excludeNullValues, onChange: () => {
                        params.excludeNullValues = !params.excludeNullValues;
                        update();
                    } }) })),
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'For Workflow Status', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.forWorkflowStatus, onChange: () => {
                        params.forWorkflowStatus = !params.forWorkflowStatus;
                        update();
                    } }) }),
            react_1.default.createElement(core_1.FormHelperText, null, "Enable the parsing of Task Status values")),
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Enable Combining Values', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', disabled: Boolean(params.group), className: 'checkbox', checked: !!params.enableCombiningValues, onChange: () => {
                        params.enableCombiningValues = !params.enableCombiningValues;
                        update();
                    } }) }),
            react_1.default.createElement(core_1.FormHelperText, null, "Enable the combining of duplicate items/labels values")),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Enable grouping', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.group, onChange: () => {
                        // disable combining values if grouping is enabled
                        // since combining values is limited only for single items
                        if (params.enableCombiningValues) {
                            params.enableCombiningValues = false;
                        }
                        params.group = params.group ? undefined : {};
                        update();
                    } }) })),
        params.group && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledConfigFieldControl, null,
                react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, value: params.group.columnName || null, options: queryManager.queryAliasColumnMap.map(columnMap => columnMap.path), onChange: (_, value) => {
                        var _a, _b;
                        if (params.group) {
                            params.group.columnName = value || undefined;
                            if (value) {
                                // get selected column type
                                const [alias, property] = value.split('.');
                                params.group.columnType = (_b = (_a = entities === null || entities === void 0 ? void 0 : entities.find(entity => entity.tableName === (0, core_2.tableCase)(alias))) === null || _a === void 0 ? void 0 : _a.columns.find(column => column.name === property)) === null || _b === void 0 ? void 0 : _b.type;
                            }
                        }
                        update();
                    }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Select Grouping Field' }))) }),
                react_1.default.createElement(core_1.FormHelperText, null, "Select the field value that will be used for grouping"))))));
};
exports.BarChartQueryBuilder = BarChartQueryBuilder;
exports.BarChartQueryBuilderPlugin = {
    name: 'Bar Chart',
    type: 'BarChart',
    component: exports.BarChartQueryBuilder
};
//# sourceMappingURL=BarChartQueryBuilderPlugin.js.map